import { FaRegUserCircle } from 'react-icons/fa';
import { TbUserCircle } from 'react-icons/tb';
import { MdLogout } from 'react-icons/md';
import logo from '../../resources/images/logo.png';
import { useEffect, useState } from 'react';
import { getUser, EUserType, TUser, UserModal, UserModalItem, Header as SharedHeader, HeaderMenuItem, EPage } from '@sifrovacihra/shared-ui';
import { useAction, useAppState } from '../../store';
import { AUTH_COOKIE, deleteCookie } from '../../utils';
import { useNavigate } from "react-router-dom";

type HeaderProps = {
    handleLoginModalOpen: () => void
}

export const Header = ({ handleLoginModalOpen }: HeaderProps) => {
    const navigate = useNavigate()
    const { state } = useAppState()
    const [user, setUser] = useState<TUser | undefined>(undefined)
    const [userModalVisible, setUserModalVisible] = useState(false)
    const { setTokenAction } = useAction()

    useEffect(() => {
        if (state?.token) {
            getUser({ token: state.token }).then((response) => {
                if (response.user) {
                    setUser(response.user)
                }
            })
        } else {
            setUser(undefined)
        }
    }, [state?.token])

    const logout = () => {
        setUser(undefined)
        setTokenAction(undefined)
        deleteCookie(AUTH_COOKIE)
        setUserModalVisible(false)
    }

    const onLoginAreaClick = () => {
        if (state?.token) {
            setUserModalVisible(!userModalVisible)
        } else {
            handleLoginModalOpen()
        }
    }

    const item = (text: string, page: EPage): HeaderMenuItem => ({
        key: page,
        text,
        href: `/${page}`,
        onClick: () => navigate(page),
    })

    const isAdmin = user?.Type === EUserType.ADMIN

    const items: HeaderMenuItem[] = [
        item('Domů', EPage.HOME),
        item('Pravidla', EPage.RULES),
        item('Přihlášené týmy', EPage.TEAMS),
        item('Statistiky', EPage.STATS),
        item('Diskuze', EPage.FORUM),
        item('Minulé ročníky', EPage.HISTORY),
        ...(isAdmin ? [item('Admin', EPage.ADMIN)] : []),
    ]

    const mobileExtraItems: HeaderMenuItem[] = [
        ...(user ? [item('Váš tým', EPage.REGISTRATION)] : []),
        user
            ? { key: 'logout', text: 'Odhlásit se', icon: <MdLogout size={20} />, onClick: logout }
            : { key: 'login', text: 'Přihlásit se', icon: <TbUserCircle size={20} />, onClick: handleLoginModalOpen },
    ]

    const userModalItems: UserModalItem[] = [
        { key: 'team', text: 'Stránka týmu', icon: <TbUserCircle size={20} />, onClick: () => { navigate(EPage.REGISTRATION); setUserModalVisible(false) } },
        { key: 'logout', text: 'Odhlásit se', icon: <MdLogout size={20} />, onClick: logout },
    ]

    return (
        <SharedHeader
            logo={<img src={logo} alt="Logo" onClick={() => navigate(EPage.HOME)} />}
            items={items}
            loginText={state?.token ? (user?.Name ?? '…') : 'Přihlásit se'}
            loginIcon={<FaRegUserCircle size={32} />}
            onLoginClick={onLoginAreaClick}
            mobileExtraItems={mobileExtraItems}
        >
            <UserModal
                visible={userModalVisible}
                closeClick={() => setUserModalVisible(false)}
                items={userModalItems}
            />
        </SharedHeader>
    )
}
